module.exports = __webpack_public_path__ + "static/media/file-search.d4811ebf.svg";